import React from 'react';

const AnswerMessage = ({ question, answer }) => {
  return (
    <li className="message-row message-row-right" key={`${question.id}-answer`}>
      <div className="message-default message-questionnaire">
        <h5>{answer}</h5>
      </div>
    </li>
  );
}

export default AnswerMessage;
